<template>
    <div class="main-data-workplantconfig">
        <div class="opera-btn">
            <el-button type="primary" @click="saveWorkPlantConfig">保存</el-button>
            <el-button  @click="cancelWorkPlantConfig">取消</el-button>
        </div>
        <div class="main-data-workplantconfig-content">
            <div class="content-box">
                <el-transfer filterable v-model="value" :data="data" :titles="['系统功能菜单', '已选菜单']"></el-transfer>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {} from '@/data-model';
export default{
    components: {

    },
    props: {
        dataList: {
            type: Array
        }
    },
    computed: {
        ...mapGetters([
            'routers'
        ])
    },
    data () {
        return {
            value: [],
            data: []
        };
    },
    created () {
        this.data = [];
        for (let i = 0; i < this.routers.length; i++) {
            let menu = this.routers[i].children;
            for (let j = 0; j < menu.length; j++) {
                let obj = menu[j];
                if (obj.isEntry === true) {
                    let o = {key: obj.id, label: obj.meta.title, path: obj.path, name: obj.name};
                    this.data.push(o);
                }
            }
        }
        if (this.dataList && this.dataList.length > 0) {
            this.value = [];
            for (let i = 0; i < this.dataList.length; i++) {
                this.value.push(this.dataList[i].key);
            }
        }
    },
    methods: {
        cancelWorkPlantConfig () {
            this.$emit('closeWorkPlantConfig');
        },
        saveWorkPlantConfig () {
            let obj = [];
            for (let i = 0; i < this.value.length; i++) {
                let cur = this.value[i];
                let o = this.data.find(item => item.key === cur);
                obj.push(o);
            }
            this.$emit('configWorkPlantConfig', obj);
        }
    }
};
</script>

<style lang="less">
    .showWorkPlantConfig{
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding-top: 0px;
            width: 98%;
            height: 90%;
            .main-data-workplantconfig{
                width: 100%;
                height: 100%;
                text-align: center;
                .opera-btn{
                    height: 40px;
                    line-height: 40px;
                    text-align: right;
                    margin-bottom: 10px;
                    margin-top: 10px;
                }
            }
            .main-data-workplantconfig-content{
                width: 100%;
                height: 100%;
                .content-box{
                    text-align: left;
                    height: 100%;
                    width: 50%;
                    margin-left: 35%;
                    .el-transfer{
                        height: 90%;
                        .el-transfer-panel{
                            height: 100%;
                            .el-transfer-panel__body{
                                height: 100%;
                                .el-checkbox-group{
                                   height: 80%;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/WorkPlantConfig.vue